<template>
  <transition name="el-fade-in">
    <div class="questionnaire-dialog">
      <div :class="{ 'container': true, 'containerSub': !isNewYear }">
        <div class="header">
          <div class="header-close-btn">
            <i class="el-icon-close" @click="closeDialog"></i>
          </div>
        </div>
        <div class="main">
          <div class="main-button" @click="toQuestionnaire"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getCookie, setCookie } from "@/ask/cookiejs";
export default {
  components: {

  },
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog', false);
    },
    toQuestionnaire() {
      let customerID = getCookie('customerID') || 0;
      let w = window.open();
      let questionnaireCode = this.isNewYear ? 'by20221227' : 'yx20240517';//'aa20131206';//'BY20230612';
      w.location.href = this.$nuxtPage + `questionnaire.html?code=${questionnaireCode}&userId=${customerID}&uerType=2&visitId=0`;
      this.closeDialog();
    },
  },
};
</script>

<style scoped lang="scss">
.margin-left_8 {
  margin-left: 8px;
}

.margin-left_16 {
  margin-left: 16px;
}

.padding-left_8 {
  padding-left: 8px;
}

.padding-left_16 {
  padding-left: 16px;
}

.padding-top_24 {
  padding-top: 24px !important;
}

.questionnaire-dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  .container {
    width: 316px;
    height: 325px;
    background: url('../../../../../../static/newStatic/img/newYear/调查问卷弹窗切图@2x.png');
    background-size: 316px 325px;
    // border-radius: 4px;

    .header {
      // padding: 16px 24px;
      height: 56px;
      display: flex;
      justify-content: flex-end;
      box-sizing: border-box;

      .header-title {
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }

      .header-title-btn {
        outline: none;
        border: none;
        width: 32px;
        height: 20px;
        background: rgba(216, 63, 63, 0.12);
        border-radius: 4px;
        box-sizing: border-box;

        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #d83f3f;
          line-height: 20px;
        }
      }

      .header-close-btn {
        margin-top: -12px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        background: #C2C2C2;
        border-radius: 50%;
        box-sizing: border-box;
        transition: 0.2s background ease-in-out;
        border: 1px solid rgba(255,255,255,0.4);
        i {
          display: inline-block;
          font-size: 12px;
          color: #FFFFFF;

          
        }

        &:hover {
            cursor: pointer;
            background: #CCCCCC;
        }

        &:active {
          cursor: pointer;
          background: #A3A3A3;
        }
      }
    }

    .main {
      height: auto;

      .main-button {
        position: relative;
        top: 230px;
        left: 85px;
        width: 150px;
        height: 49px;
        cursor: pointer;
        background: url('../../../.././../../static/newStatic/img/newYear/bt_wenjuan_n@2x.png');
        background-size: 150px 49px;
        transition: 0.2s background ease-in-out;

        &:hover {
          background: url('../../../.././../../static/newStatic/img/newYear/bt_wenjuan_h@2x.png');
          background-size: 150px 49px;
        }

        &:active {
          background: url('../../../.././../../static/newStatic/img/newYear/bt_wenjuan_c@2x.png');
          background-size: 150px 49px;
        }
      }
    }
  }

  .containerSub {
    background: url('../../../.././../../static/newStatic/img/newYear/弹窗主体@2x.png');
    background-size: 316px 325px;

    .main {

      .main-button {
        position: relative;
        top: 230px;
        left: 85px;
        width: 150px;
        height: 48px;
        cursor: pointer;
        background: url('../../../.././../../static/newStatic/img/newYear/调查问卷button_normal@2x.png');
        background-size: 150px 48px;
        transition: 0.2s background ease-in-out;

        &:hover {
          background: url('../../../.././../../static/newStatic/img/newYear/调查问卷button_hover@2x.png');
          background-size: 150px 48px;
        }

        &:active {
          background: url('../../../.././../../static/newStatic/img/newYear/调查问卷button_active@2x.png');
          background-size: 150px 48px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/home/public/navTopHeader/questionnaireDialog.vue